import {SET_EVENT_TO_BACKEND_SNAPSHOT} from '~/common/fabric/constants';

export const setEventToBackendSnapshot = (data) => ({
  type: SET_EVENT_TO_BACKEND_SNAPSHOT,
  payload: data,
});

const initialState = {
  data: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EVENT_TO_BACKEND_SNAPSHOT:
      return {
        eventToBackend: action.payload,
      };
    default:
      return state;
  }
};
